import { ASSET_PREFIX } from "utils/constants";
import DrawCountdownString from "../draw-countdown/DrawCountdown";
import styles from './HeroFooter.module.css';

interface IHeroFooter {
    isInstantRaffle: boolean;
    drawDate: Date | null;
}

const HeroFooter = ({isInstantRaffle, drawDate }: IHeroFooter) => {

    return (
        <div className={styles.heroFooterContainer}>
            {isInstantRaffle && (
                <div className={styles.heroFooterBanner}>
                    <img className={styles.bannerIcon} src={`${ASSET_PREFIX}/images/token-town/trophy-icon.svg`} />
                    <p>1 GUARANTEED WINNER</p>
                    <img className={styles.bannerIcon} src={`${ASSET_PREFIX}/images/token-town/trophy-icon.svg`} />
                </div>
            )}

            {drawDate && !isInstantRaffle && (
                <div className={styles.heroFooterBanner}>
                    <img className={styles.bannerIcon} src={`${ASSET_PREFIX}/images/token-town/clock-icon.svg`} />
                    <p style={{textTransform: 'uppercase'}}>Next draw in <DrawCountdownString date={drawDate} /></p>
                    <img className={styles.bannerIcon} src={`${ASSET_PREFIX}/images/token-town/clock-icon.svg`} />
                </div>
            )}
        </div>
    )
}

export default HeroFooter